import React from 'react'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import { Paper, Typography, Box, Divider, Button } from '@material-ui/core'

import * as service from 'service'

import { Permitted } from 'components/Permissions'
import SettingsAddressTable from './components/SettingsAddressTable'
import SettingsAddressFrom from './components/SettingsAddressForm'

const SettingsAddressMain = () => {
  const snackbar = useSnackbar()
  const sellerId = 1
  const [edit, setEdit] = React.useState(false)
  const { response, isLoading, refresh } = useFetch(
    service.recurrence.sellers.get,
    {
      sellerId,
    },
  )

  const onSubmit = async data => {
    try {
      await service.recurrence.sellers.update({
        sellerId,
        addressAttributes: data,
      })
      refresh()

      snackbar.open({
        message: 'Endereço atualizado sucesso!',
        variant: 'success',
      })
      setEdit(false)
    } catch (exception) {
      const message =
        exception &&
        exception.response &&
        exception.response.data &&
        exception.response.data.error &&
        exception.response.data.error.message

      snackbar.open({
        message: `Falha ao atualizar endereço! ${message}`,
        variant: 'error',
      })
      setEdit(false)
    }
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Sua localização</Typography>
        <Permitted tag="update_seller">
          {!edit ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setEdit(true)}
            >
              Editar
            </Button>
          ) : null}
        </Permitted>
      </Box>
      <Divider />

      {edit && !isLoading ? (
        <SettingsAddressFrom
          address={
            response &&
            response.data &&
            response.data.seller &&
            response.data.seller.address
          }
          onSubmit={onSubmit}
          handleClose={setEdit}
        />
      ) : (
        <SettingsAddressTable
          address={
            response &&
            response.data &&
            response.data.seller &&
            response.data.seller.address
          }
          isLoading={isLoading}
        />
      )}
    </Paper>
  )
}

export default SettingsAddressMain
